/**
 * @class Ticket
 */
export default class Ticket {
    /**
     * @param {Number}  id
     * @param {Number}  ticketId
     * @param {Number}  type
     * @param {Number}  status
     * @param {Boolean}  read
     * @param {Boolean}  active
     * @param {String}  subject
     * @param {String}  request
     * @param {String}  answer
     * @param {String}  operator
     * @param {String}  resolvedBy
     * @param {Customer}  customer
     * @param {Fandeck}  fandeck
     * @param {Color}  color
     * @param {Product}  product
     * @param {Base}  base
     * @param {Date}  requestDate
     * @param {Date}  answerDate
     * @param {Object} jsonAttributes
     * @param {Array} attachmentsRequest
     * @param {Array} attachmentsAnswer
     * @param {Number} formulaCombinationId
     */
    constructor(
        id,
        ticketId,
        type,
        status,
        read,
        active,
        subject,
        request,
        answer,
        operator,
        resolvedBy,
        customer,
        fandeck,
        color,
        product,
        base,
        requestDate,
        answerDate,
        jsonAttributes,
        attachmentsRequest,
        attachmentsAnswer,
        formulaCombinationId
    ) {
        this._id = id;
        this._ticketId = ticketId;
        this._type = type;
        this._status = status;
        this._read = read;
        this._active = active;
        this._subject = subject;
        this._request = request;
        this._answer = answer;
        this._operator = operator;
        this._resolvedBy = resolvedBy;
        this._customer = customer;
        this._fandeck = fandeck;
        this._color = color;
        this._product = product;
        this._base = base;
        this._requestDate = requestDate;
        this._answerDate = answerDate;
        this._jsonAttributes = jsonAttributes;
        this._attachmentsRequest = attachmentsRequest ?? [];
        this._attachmentsAnswer = attachmentsAnswer ?? [];
        this._formulaCombinationId = formulaCombinationId;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Ticket");
        }
        this._attachmentsRequest = attachmentsRequest;
        this._attachmentsAnswer = attachmentsAnswer;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get ticketId() {
        return this._ticketId;
    }

    set ticketId(value) {
        this._ticketId = value;
    }

    get type() {
        return this._type;
    }

    set type(value) {
        this._type = value;
    }

    get status() {
        return this._status;
    }

    set status(value) {
        this._status = value;
    }

    get read() {
        return this._read;
    }

    set read(value) {
        this._read = value;
    }

    get active() {
        return this._active;
    }

    set active(value) {
        this._active = value;
    }

    get subject() {
        return this._subject;
    }

    set subject(value) {
        this._subject = value;
    }

    get request() {
        return this._request;
    }

    set request(value) {
        this._request = value;
    }

    get answer() {
        return this._answer;
    }

    set answer(value) {
        this._answer = value;
    }

    get operator() {
        return this._operator;
    }

    set operator(value) {
        this._operator = value;
    }

    get resolvedBy() {
        return this._resolvedBy;
    }

    set resolvedBy(value) {
        this._resolvedBy = value;
    }

    get customer() {
        return this._customer;
    }

    set customer(value) {
        this._customer = value;
    }

    get fandeck() {
        return this._fandeck;
    }

    set fandeck(value) {
        this._fandeck = value;
    }

    get color() {
        return this._color;
    }

    set color(value) {
        this._color = value;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    get base() {
        return this._base;
    }

    set base(value) {
        this._base = value;
    }

    get requestDate() {
        return this._requestDate;
    }

    set requestDate(value) {
        this._requestDate = value;
    }

    get answerDate() {
        return this._answerDate;
    }

    set answerDate(value) {
        this._answerDate = value;
    }

    get jsonAttributes() {
        return this._jsonAttributes;
    }

    set jsonAttributes(value) {
        this._jsonAttributes = value;
    }

    get attachmentsRequest() {
        return this._attachmentsRequest;
    }

    set attachmentsRequest(value) {
        this._attachmentsRequest = value;
    }

    get attachmentsAnswer() {
        return this._attachmentsAnswer;
    }

    set attachmentsAnswer(value) {
        this._attachmentsAnswer = value;
    }

    get formulaCombinationId() {
        return this._formulaCombinationId;
    }

    set formulaCombinationId(value) {
        this._formulaCombinationId = value;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Ticket POS_ID: (" + this._id + "), ID: (" + this._ticketId + ")";
    }
}
